
import React from 'react'
import './index.scss'

export interface AiGroupProps {
    name?: React.ReactNode | string //名称
    style?: any //名称
    children?:React.ReactNode | string // 右上角的图标
}
const AiGroup: React.FC<AiGroupProps> = ({name = '',  style = {}, ...props}) => {
    return (
        <div className='ai-group-wrapper-item'>
            <article className='ai-card-group-wrapper' style={{...style}}>
                <div className='ai-card-group-wrapper-item'>
                    {props?.children && props?.children}
                </div>
                <p>{name}</p>
            </article>
        </div>   
    )
}

export default AiGroup

export interface GroupProps {
    children?:React.ReactNode | string // 右上角的图标
    style?: any //名称
}

export const Group: React.FC<GroupProps> = (props) => {
    return (
        <>
            <article className='ai-group-wrapper' style={props?.style || {}}>
                {props?.children}
            </article>
        </>    
    )
}

